/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomerandSuppliersbyCityListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: CustomerandSuppliersbyCityService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, HostBinding, EventEmitter, Input, Output, OnInit, ViewChild,
	trigger, transition, animate,
	style, state } from '@angular/core';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastsManager }  from 'ng2-toastr';
import myGlobals = require('../globals');

import { CustomerandSuppliersbyCityData, CustomerandSuppliersbyCityService } from './CustomerandSuppliersbyCity.service';
import { CustomerandSuppliersbyCitySearchComponent }  from './CustomerandSuppliersbyCitySearch.component';

@Component({
	selector: 'my-CustomerandSuppliersbyCity',
	template: require('./CustomerandSuppliersbyCityList.component.html'),
	providers: [CustomerandSuppliersbyCityService],
	animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.4s ease-in')
      ]),
      transition(':leave', [
        animate('0.7s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class CustomerandSuppliersbyCityListComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}
	
	CustomerandSuppliersbyCityList: CustomerandSuppliersbyCityData[];
	newCustomerandSuppliersbyCity: CustomerandSuppliersbyCityData;
	selectedCustomerandSuppliersbyCity: CustomerandSuppliersbyCityData;
	errorMessage: string;
	messages: string[];
	showAdd: boolean;
	@ViewChild(CustomerandSuppliersbyCitySearchComponent) filterComponent: CustomerandSuppliersbyCitySearchComponent;

	sortExpression: string = "City";
	filterExpression: string = "";
	pageIndex: number = 1;
	pageSize: number = 10;
	endRowIndex: number;
	rowsCount: number;
	pageCount: number;
	isFirstPage: boolean;

    private selectedId: string;

	constructor(
		private CustomerandSuppliersbyCityService: CustomerandSuppliersbyCityService,
		private route: ActivatedRoute,
		private router: Router,
		private toastr: ToastsManager
	) {
		this.newCustomerandSuppliersbyCity = new CustomerandSuppliersbyCityData();
		this.pageSize = myGlobals.pageSize;
	}

	ngOnInit() {
		// this.CustomerandSuppliersbyCityService.getAll().subscribe(record => this.CustomerandSuppliersbyCityList=record);
		this.pageIndex = 1;
		this.isFirstPage = true;
		this.getCustomerandSuppliersbyCityByPaging();

		/*
		this.CustomerandSuppliersbyCityList = this.route.params
			.switchMap((params: Params) => {
				this.selectedId = +params['id'];
				return this.service.getAll();
			});
		*/
	}

	// Get all records
	public getCustomerandSuppliersbyCity() {
		this.CustomerandSuppliersbyCityService.getAll()
			.subscribe(data => this.CustomerandSuppliersbyCityList = data,
		error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error);
	}
	
	// On Search CLick on CustomerandSuppliersbyCitySearch Component
	onSearch(searchText: string) {
		// 1. Update this.filterExpression
		this.filterExpression = searchText;

		// 2. call getCustomerandSuppliersbyCityByPaging method that will refresh the data
		this.pageIndex = 1;
		this.getCustomerandSuppliersbyCityByPaging();
	}
	
	onSort(event, sortColumn: string)
	{
		// var target = event.target || event.srcElement || event.currentTarget;
		// var parent = target.parentNode;
		if (this.sortExpression === sortColumn)
			this.sortExpression = sortColumn + ' desc';
		else if (this.sortExpression === sortColumn + ' desc')
			this.sortExpression = sortColumn;
		else
			this.sortExpression = sortColumn;
		this.getCustomerandSuppliersbyCityByPaging();
	}
	
	// Get records by paging
	getCustomerandSuppliersbyCityByPaging() {
		this.CustomerandSuppliersbyCityService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
			.subscribe(data => {
				this.CustomerandSuppliersbyCityList=data.CustomerandSuppliersbyCityList;
				this.rowsCount=data.RowsCount; 
				this.pageCount= Math.ceil(this.rowsCount / this.pageSize);
				if (this.pageIndex == 1)
					this.isFirstPage = true;
				else
					this.isFirstPage = false;
				if (this.pageIndex == this.pageCount)
					this.endRowIndex = this.rowsCount;
				else
					this.endRowIndex = this.pageIndex * this.pageSize;
			},
			error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error
		);
	}
	// Adds new record
	addCustomerandSuppliersbyCity() {
		this.CustomerandSuppliersbyCityService.addCustomerandSuppliersbyCityData(this.newCustomerandSuppliersbyCity).subscribe(record => console.log(record));
		this.getCustomerandSuppliersbyCity();
	}
  
	// Updates existing record
	updateCustomerandSuppliersbyCity() {
		this.CustomerandSuppliersbyCityService.updateCustomerandSuppliersbyCityData(this.selectedCustomerandSuppliersbyCity).subscribe(record => console.log(record));
		this.getCustomerandSuppliersbyCity();
	}

	// Deletes record with specified id
	deleteCustomerandSuppliersbyCity(id: string) {
		if (window.confirm('Are you sure you want to delete this CustomerandSuppliersbyCity?') == true)
		{
			this.CustomerandSuppliersbyCityService.deleteCustomerandSuppliersbyCity(id)
			.subscribe(data => this.getCustomerandSuppliersbyCity(), 
			error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error);
		}
	}

	// Go to First Page
	onFirstPage() {
		this.pageIndex = 1;
		this.getCustomerandSuppliersbyCityByPaging();
	}

	// Go to Previous Page
	onPreviousPage() {
		if (this.pageIndex > 1) {
			this.pageIndex = this.pageIndex - 1;
			this.getCustomerandSuppliersbyCityByPaging();
		}
	}

	// Go to Next Page
	onNextPage() {
		if (this.pageIndex < this.pageCount) {
			this.pageIndex = this.pageIndex + 1;
			this.getCustomerandSuppliersbyCityByPaging();
		}
	}

	// Go to Last Page
	onLastPage() {
		this.pageIndex = this.pageCount;
		this.getCustomerandSuppliersbyCityByPaging();
	}

	// Refresh - Go to First Page
	onRefresh() {
		this.onFirstPage();
	}

	// On Edit - Go to Edit page
	onSelect(item: CustomerandSuppliersbyCityData) {
		this.router.navigate(['/CustomerandSuppliersbyCity', item.City]);
	}

	// On Details - Go to Details page
	onSelectDetails(item: CustomerandSuppliersbyCityData) {
		this.router.navigate(['/CustomerandSuppliersbyCity/Details', item.City]);
	}

	// Set record as selected
	SelectCustomerandSuppliersbyCity(item: CustomerandSuppliersbyCityData) {
		this.selectedCustomerandSuppliersbyCity = item;
	}

	// Submits form
	submitForm(data: Object) {
		console.log(data);
	}

	// Logs message onto Console
	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}

/*
	isSelected(item: CustomerandSuppliersbyCityData) {
		return item.City === this.selectedId;
	}
*/
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/CustomerandSuppliersbyCity/CustomerandSuppliersbyCityList.component.ts